// ======================================================================
// FILE:
// src/modules/finance/services/customerLedgerService.js
//
// MODULE:
// Finance & Accounts Management System
//
// FEATURE:
// Customer Ledger
//
// PURPOSE:
// Read-only API service for Customer Ledger.
// ======================================================================

import axiosClient from "../../../api/axiosClient";

const BASE_URL = "/api/finance/receivables";

// ======================================================================
// GET CUSTOMER LEDGER
// ======================================================================

async function getCustomerLedger({
    customerId,
    fromDate = "",
    toDate = "",
}) {
    if (!customerId) {
        throw new Error("Please select a customer.");
    }

    const response = await axiosClient.get(
        `${BASE_URL}/customer-ledger`,
        {
            params: {
                customer_id: customerId,
                ...(fromDate && {
                    from_date: fromDate,
                }),
                ...(toDate && {
                    to_date: toDate,
                }),
            },
        }
    );

    if (!response.data?.success) {
        throw new Error(
            response.data?.message ||
            "Failed to load Customer Ledger."
        );
    }

    return response.data.data;
}

// ======================================================================
// EXPORT
// ======================================================================

const customerLedgerService = {
    getCustomerLedger,
};

export default customerLedgerService;